/** The swallowed-fetch-error breadcrumb (contract 10 §7) carried to the vendor via a seam. */
export interface ScorecardFetchFailure {
  kind: string
  status: number | null
  code: string | null
}

export type ScorecardFetchFailureReporter = (failure: ScorecardFetchFailure) => void

const noopReporter: ScorecardFetchFailureReporter = () => {
  /* telemetry is optional until the app composition registers a reporter */
}
let fetchFailureReporter = noopReporter

/** App composition registers the vendor-backed reporter without leaking Sentry into the feature. */
export function registerScorecardFetchFailureReporter(
  reporter: ScorecardFetchFailureReporter,
): () => void {
  fetchFailureReporter = reporter
  return () => {
    if (fetchFailureReporter === reporter) fetchFailureReporter = noopReporter
  }
}

export function reportScorecardFetchFailure(failure: ScorecardFetchFailure): void {
  fetchFailureReporter(failure)
}
